import { type Profile } from "../../profile/profile.models";

declare global {
  interface Window {
    Wized: any;
  }
}

class WizedService {
  async onLogin(infos: Profile) {
    if (!window.Wized) { console.info("Wized is not defined"); return }

    if (!infos.email) { console.info("email is not defined"); return }
    if (!infos.id) { console.info("id is not defined"); return }

    window.Wized.data.setVariable("privyLibEmail", infos.email)
    window.Wized.data.setVariable("userId", infos.id)

    try {
      await window.Wized.request.execute(".getUserLoginV3")
    } catch (error) { console.log("Wized error", error) }
  }
}

export const wizedService = new WizedService()
